import img from '../../Images/sv.png';
import img1 from '../../Images/sv1.png';
import img2 from '../../Images/jpeg2.jpg';


export const homeObjOne={
    lightBg:false,
    primary:true,
    imgStart:'',
    lightTopLine:true,
    lightTextDesc:true,
    topLine:'Web Development Agency',
    lightText:true,
    headline:'Hislordship consult',
    description:'welcome to hislordship services we are ready and willing to server you with the very best',
    buttonLabel:'Get Started',
    img:img,
    alt:'Images-cs',
    start:'',
}

export const homeObjtwo={
    lightBg:true,
    primary:false,
    imgStart:'start',
    lightTopLine:false,
    lightTextDesc:false,
    topLine:'Social Media Content Manger',
    lightText:false,
    headline:'Hislordship consult',
    description:'welcome to hislordship services we are ready and willing to server you with the very best',
    buttonLabel:'Get Started',
    img:img,
    alt:'Images-cs',
    start:'true',
}

export const homeObjthree={
    lightBg:false,
    primary:true,
    imgStart:'',
    lightTopLine:true,
    lightTextDesc:true,
    topLine:'Mobile App Development Agency',
    lightText:true,
    headline:'Hislordship Mobile App Consult',
    description:'welcome to hislordship services we are ready and willing to server you with the very best',
    buttonLabel:'Get Started',
    img:img1,
    alt:'Images-cs',
    start:'',
}

export const homeObjfour={
    lightBg:true,
    primary:false,
    imgStart:'start',
    lightTopLine:false,
    lightTextDesc:false,
    topLine:'Adobe-PhotoShop Services',
    lightText:false,
    headline:'Hislordship consult',
    description:'welcome to hislordship services we are ready and willing to server you with the very best',
    buttonLabel:'Get Started',
    img:img2,
    alt:'Images-cs',
    start:'',
}